import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import Layout from '@/components/Layout';
import Home from '@/components/Resources/Subject/Home';

export const getServerSideProps: GetServerSideProps = async ({
  locale = '',
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'resources',
        'path',
      ])),
    },
  };
};

const SubjectPage = () => {
  return <Home />;
};

export default SubjectPage;

SubjectPage.getLayout = (page: React.ReactElement) => (
  <Layout tooterTheme="home">{page}</Layout>
);
